import client from '@common/utils/rest';

const URL_PREFIX = 'api/folders/formats/letters';

export const getFolders = () => {
    const allFoldersParameters = {
        folderId: '-1'
    };

    return client({
        params: allFoldersParameters,
        path: URL_PREFIX,
        method: 'GET'
    }).then(
        (response) => {
            return response.entity;
        },
    );
};

export const createFolder = (parentFolderId) => {
    return client({
        params: {
            folderId: parentFolderId,
        },
        path: URL_PREFIX,
        method: 'POST'
    }).then((x) => x.entity);
};

export const renameFolder = (folderId, folderName) => {
    return client({
        params: {
            folderId,
            folderName
        },
        path: `${URL_PREFIX}/rename`,
        method: 'POST'
    });
};

export const moveFolder = (movingId, toFolderId) => {
    return client({
        params: {
            fromFolderId: movingId,
            toFolderId
        },
        path: `${URL_PREFIX}/move`,
        method: 'POST'
    });
};

export const deleteFolder = (folderId) => {
    return client({
        params: {
            folderId
        },
        path: `${URL_PREFIX}/delete`,
        method: 'POST'
    });
};